import React from 'react';
import { Trans } from '@lingui/react';

export interface IHumanReadableError {
  type:
    | 'email_already_in_use'
    | 'email_exists'
    | 'invalid_email'
    | 'invalid_username'
    | 'invalid_username_prev_email'
    | 'invalid_otp'
    | 'unverified_code'
    | 'expired_otp'
    | 'unknown_error';
}

export const errorMessagesIndex: Record<
  IHumanReadableError['type'],
  JSX.Element
> = {
  email_already_in_use: (
    <Trans id="This username has been taken, please enter a new unique username" />
  ),
  email_exists: (
    <Trans id="This email has been taken by another user. Please select a new unique email address." />
  ),
  invalid_username_prev_email: (
    <Trans id="Previous username was an email, please enter a valid email." />
  ),
  invalid_email: <Trans id="Please provide a valid email" />,
  invalid_otp: (
    <Trans id="Entered code does not match the code sent. Please try again." />
  ),
  expired_otp: <Trans id="Entered code has expired. Please try again." />,
  unverified_code: <Trans id="Unable to verify code. Please try again." />,
  invalid_username: <Trans id="Please provide a valid username." />,
  unknown_error: <Trans id="An error occurred. Please try again." />,
};
